import { ReactElement } from 'react';
import PriceSchemesWizard from './PriceSchemesWizard';
import { IPriceSchemesModal } from './types';
import { Modal } from '@weareopenr/component-library';

import chefPlating from 'src/assets/images/chef-plating.png';

const PriceSchemesModal = ({
  closeModal,
  open,
  priceSchemes = [],
  priceSchemeId,
  duplicateSchemeId,
}: IPriceSchemesModal): ReactElement => {
  const wizardKey = `${priceSchemeId}|${duplicateSchemeId}|${priceSchemes.length > 0}`;

  return (
    <Modal open={open} closeModal={closeModal} image={chefPlating} imageAlt="Chef plating">
      <PriceSchemesWizard
        key={wizardKey}
        closeModal={closeModal}
        priceSchemeId={priceSchemeId}
        duplicateSchemeId={duplicateSchemeId}
        priceSchemes={priceSchemes}
      />
    </Modal>
  );
};

export default PriceSchemesModal;
